"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getIsFileAccessibleAnonymously;

function getIsFileAccessibleAnonymously(file) {
  var allowsAnonymousAccess = file.getIn(['meta', 'allows_anonymous_access']);
  return allowsAnonymousAccess == null ? true : allowsAnonymousAccess;
}

module.exports = exports.default;